// libs
import React, { memo } from 'react';

// icons
import { styled } from '@nykaa/ui-components';
import ChevronLeft from '@nykaa/ui-components/Icons/chevron-left';
import ChevronRight from '@nykaa/ui-components/Icons/chevron-right';

// hook
import useTheme from '@nykaa/ui-components/themes/hooks/useTheme';

// types
import { Theme } from '@nykaa/ui-components/themes/types';

// styles

const NavWrapper = styled.span`
  ${({ theme }) =>
    `.next{
     margin-left: -19px;
    -webkit-filter: drop-shadow( ${theme.spacing.spacing20} ${theme.spacing.spacing10} 1px ${theme.colors.primary});
    filter: drop-shadow(${theme.spacing.spacing20} ${theme.spacing.spacing10} 1px );
     }
      .prev{
    -webkit-filter: drop-shadow( ${theme.spacing.spacing20} ${theme.spacing.spacing10} 1px ${theme.colors.primary});
    filter: drop-shadow(-${theme.spacing.spacing10} 1px 1px );
      }
    `}
`;

interface INavButtonProps {
  type: 'prev' | 'next';
}
export const NAV_BUTTON_TYPES = {
  PREV: 'prev',
  NEXT: 'next',
};

function NavButton({ type }: INavButtonProps) {
  const theme: Theme = useTheme();
  return (
    <NavWrapper className={type}>
      {type === NAV_BUTTON_TYPES.PREV && <ChevronLeft color={theme.colors.white} />}
      {type === NAV_BUTTON_TYPES.NEXT && <ChevronRight color={theme.colors.white} />}
    </NavWrapper>
  );
}
export default memo(NavButton);
